import React from 'react';

export const TeamContext = React.createContext();
